<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Product Type</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="productType.id === null">New</span>
              <span v-else>
                {{ productType.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="productType.name" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
        <ul class="nav nav-tabs nav-bordered">
          <li class="nav-item">
            <a href="#account" data-toggle="tab" aria-expanded="false" class="nav-link active">
              General
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="account">
            <table class="table table-sm table-item">
              <thead>
                <th>Account</th>
                <th>Type</th>
                <th>Description</th>
                <th>Company</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(ac, index) in productType.accounts" :key="ac.id">
                  <td>
                    <v-select :options="getAccountList" :reduce="account => account.meta.code" label="account" @input="setCom(index)" v-model="ac.account_code"/>
                  </td>
                  <td>
                    <select v-model="ac.type_id" class="form-control">
                      <option v-for="at in productAccounTypeList" :key="at.id" :value="at.id">{{ at.name }}</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" v-model="ac.description" class="form-control"/>
                  </td>
                  <td>
                    <select v-model="ac.company_no" class="form-control">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-danger btn-sm" @click="removeAccount(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                    <td>
                        <span class="link-secondary" @click="addAccount">
                          Add Account
                        </span>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateProductType" class="btn btn-sm btn-primary pull-right" v-show="productType.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createProductType" class="btn btn-sm btn-primary pull-right" v-show="productType.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ productType }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { productTypeUrl, getHeader } from '../../config'

export default {
  name: 'ProductTypeForm',
  props: ['productType'],
  computed: {
    ...mapState({
      accountList: state => state.accounts.accountList,
      productAccounTypeList: state => state.products.productAccounTypeList,
      companyList: state => state.companies.companyList
    }),
    getAccountList: function () {
      var array = this.accountList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: '[' + array[i].account_code + '] ' + array[i].account_name,
          meta: {
            code: array[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    addAccount: function () {
      var obj = {
        id: null,
        ptype_id: this.productType.id ? this.productType.id : null,
        account_code: null,
        description: null,
        type_id: null,
        company_no: null
      }
      this.productType.accounts.push(obj)
    },
    setCom (index) {
      var account = this.productType.accounts[index]
      var split = account.account_code.split('-')
      var com = this.companyList.filter(c => c.acc_id === split[0])
      account.company_no = com[0].company_no
    },
    async updateProductType () {
      await axios.put(productTypeUrl + '/' + this.productType.id, this.productType, { headers: getHeader() })
        .then(response => {
          var array = this.productType.accounts
          for (let i = 0; i < array.length; i++) {
            if (array[i].id !== null) {
              axios.put(productTypeUrl + '/account/' + array[i].id, array[i], { headers: getHeader() })
                .then(response => {
                  console.log('Posted Data: ' + response.data.data.id)
                })
                .catch(error => {
                  console.log(error)
                  this.$swal('Error!!', error.message, 'error')
                })
            } else {
              axios.post(productTypeUrl + '/account', array[i], { headers: getHeader() })
                .then(response => {
                  console.log('Posted Data: ' + response.data.data.id)
                })
                .catch(error => {
                  console.log(error)
                  this.$swal('Error!!', error.message, 'error')
                })
            }
          }
          this.$swal('Product Type', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error!!', error.message, 'error')
        })
    },
    async createProductType () {
      await axios.post(productTypeUrl, this.productType, { headers: getHeader() })
        .then(response => {
          var array = this.productType.accounts
          for (let i = 0; i < array.length; i++) {
            array[i].ptype_id = response.data.data.id
            axios.post(productTypeUrl + '/account/', array[i], { headers: getHeader() })
              .then(response => {
                console.log('Posted Data: ' + response.data.data.id)
              })
              .catch(error => {
                console.log(error)
                this.$swal('Error!!', error.message, 'error')
              })
          }
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error!!', error.message, 'error')
        })
    },
    async removeAccount (index) {
      var account = this.productType.accounts[index]
      if (typeof account.id === 'undefined' || account.id === null) {
        this.productType.accounts.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(productTypeUrl + '/account/' + account.id, { headers: getHeader() })
              .then(response => {
                this.productType.accounts.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                this.$swal(
                  'Error',
                  error.message,
                  'error'
                )
              })
          }
        })
      }
    }
  }
}
</script>
